module.exports = {
    // Finance
    bookkeeping: {
        name: 'Bookkeeping',
    },
    'annual-reporting': {
        name: 'Annual reporting',
    },
    controlling: {
        name: 'Controlling',
    },
    'salary-management': {
        name: 'Salary-management',
    },
    'vat-guidance': {
        name: 'VAT-guidance',
    },

    // Web
    wordpress: {
        name: 'Wordpress website',
    },
    webshop: {
        name: 'Webshop',
    },
    programming: {
        name: 'Programming',
    },
    'static-page': {
        name: 'Static page',
    },

    // Graphic Design
    logo: {
        name: 'Logo design',
    },
    photography: {
        name: 'Photography',
    },
    print: {
        name: 'Print',
    },
    flyers: {
        name: 'Flyers / Brochures',
    },
    banners: {
        name: 'Banners',
    },

    // Online Marketing
    seo: {
        name: 'SEO',
    },
    adwords: {
        name: 'Adwords',
    },
    newsletters: {
        name: 'Newsletters',
    },
    content: {
        name: 'Content',
    },
    facebook: {
        name: 'Facebook',
    },
    linkedin: {
        name: 'LinkedIn',
    },
    analytics: {
        name: 'Analytics',
    },
    blog: {
        name: 'Blog-posts',
    },

    // Marketing
    'copy-writing': {
        name: 'Copywriting',
    },
    'market-analysis': {
        name: 'Market analysis',
    },

    groups: {
        'online-marketing': {
            name: 'Online marketing',
        },
        'graphic-design': {
            name: 'Graphic design',
        },
        marketing: {
            name: 'Marketing',
        },
        finance: {
            name: 'Finance',
        },
        web: {
            name: 'Web',
        },
    },

    'all-areas': 'All areas',
};



// WEBPACK FOOTER //
// ./src/taskflex/skills/locales/en.js